import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { Input } from "@/components/ui/input";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(username, password);
      toast.success("Welcome back");
      navigate("/admin", { replace: true });
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail, "Incorrect username or password."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen w-full bg-espresso flex items-center justify-center px-6 font-sans">
      <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
        <div className="text-center mb-10">
          <p className="font-serif text-4xl text-ivory">Angeo <span className="text-gold italic">&amp;</span> Gracie</p>
          <p className="mt-2 text-xs tracking-luxe uppercase text-gold">Private Guest Management</p>
        </div>
        <label className="text-xs tracking-luxe uppercase text-gold">Username</label>
        <Input
          type="text" value={username} onChange={(e) => setUsername(e.target.value)} required autoCapitalize="none" autoCorrect="off"
          className="mt-2 mb-5 bg-espresso-dark/60 border-gold-soft text-ivory"
          data-testid="login-username"
        />
        <label className="text-xs tracking-luxe uppercase text-gold">Password</label>
        <Input
          type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
          className="mt-2 mb-8 bg-espresso-dark/60 border-gold-soft text-ivory"
          data-testid="login-password"
        />
        <button
          type="submit" disabled={loading}
          className="w-full py-3.5 rounded-full bg-gold text-espresso-dark font-medium tracking-wide hover:bg-ivory transition-colors disabled:opacity-60"
          data-testid="login-submit"
        >
          {loading ? "Signing in..." : "Sign In"}
        </button>
      </form>
    </div>
  );
}
